// project-imports
import {
    CREATE_PRODUCTS_BEGIN,
    CREATE_PRODUCTS_SUCCESS,
    CREATE_PRODUCTS_FAILURE,
    GET_PRODUCTS_BEGIN,
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCTS_FAILURE,
    UPDATE_DOWNLOADS_ON_ENTITY_SUCCESS,
    GLOBAL_SEARCH_EBOOK_SUCCESS,
    GLOBAL_SEARCH_EBOOK_FAILURE,
} from "../constants/actions";

// State variable initialization
const initialState = {
    productLoading: false,
    productsError: null,
    allProducts: [],
    products: [],
    ebooks: [],
    filteredEBooks: [],
    searchTerm: null
};

const productReducer = (state = initialState, action) => {

    if (action.type === GET_PRODUCTS_BEGIN) {
        // Set loading state
        return {
            ...state,
            productLoading: action.payload,
            productsError: null,
            searchTerm: null,
            filteredEBooks: []
        };
    }

    if (action.type === GET_PRODUCTS_SUCCESS) {

        const response = action.payload;
        // const ordersData = action.payload?.allOrders;
        // const updatedProducts = updatedProductsCounts(response, ordersData);
        // console.log("GET_PRODUCTS_SUCCESS => ", updatedProducts || "no");
        const ebooksData = (response || [])?.filter((item) => item?.type === "ebook");
        const productsData = (response || [])?.filter((item) => (item?.type === "internship" || item?.type === "flex-learning-path") && item?.category === "salesforce" && (item?.subCategory === "development" || item?.subCategory === "administration"));
        // Update state with all product 
        return {
            ...state,
            productLoading: false,
            allProducts: response,
            products: Array.isArray(productsData) ? productsData : [],
            ebooks: Array.isArray(ebooksData) ? ebooksData : [],
            productsError: null,
            searchTerm: null,
            filteredEBooks: []
        };
    }

    if (action.type === GLOBAL_SEARCH_EBOOK_SUCCESS) {
        let filteredEBooks = [];
        let newName = "";
        const searchTerm = action.payload;
        let localState = state;

        if (searchTerm && localState) {
            filteredEBooks = localState.ebooks
                .filter((ebook) =>
                    ebook?.isActive === true && ebook.name.toLowerCase().includes(searchTerm.toLowerCase())
                )
                .map((ebook) => {
                    newName = ebook.name.replace(
                        new RegExp(searchTerm, "gi"),
                        (match) =>
                            `<mark style="background: #e7bd3c; color: white;">${match}</mark>`
                    );
                    return {
                        ...ebook,
                        name: newName,
                    };
                });
        } else {
            filteredEBooks = [];
        }

        // Update state with searched ebook
        return {
            ...state,
            filteredEBooks: filteredEBooks,
            productLoading: false,
            productsError: null,
            searchTerm: searchTerm,
        };
    }

    if (action.type === GLOBAL_SEARCH_EBOOK_FAILURE) {
        // Set error state
        return {
            ...state,
            productLoading: false,
            productsError: action.payload,
            searchTerm: null,
            filteredEBooks: []
        };
    }

    if (action.type === GET_PRODUCTS_FAILURE) {
        // Set error state
        return {
            ...state,
            productLoading: false,
            productsError: action.payload,
        };
    }

    if (action.type === CREATE_PRODUCTS_BEGIN) {
        // Set loading state
        return {
            ...state,
            productLoading: action.payload,
            productsError: null,
        };
    }

    if (action.type === CREATE_PRODUCTS_SUCCESS) {

        // Update state with added product
        return {
            ...state,
            productLoading: false,
            productsError: null,
        };
    }

    if (action.type === CREATE_PRODUCTS_FAILURE) {
        // Set error state
        return {
            ...state,
            productLoading: false,
            productsError: action.payload,
        };
    }

    if (action.type === UPDATE_DOWNLOADS_ON_ENTITY_SUCCESS) {

        const productId = action.payload?.productId;
        const productName = action.payload?.productName;
        const existingProducts = JSON.parse(JSON.stringify(state?.allProducts));

        let allProducts = existingProducts || [];
        const index = allProducts.findIndex((item) => item?.productCode === productId);
        if (index > -1) {
            allProducts[index] = {
                ...allProducts[index],
                metadata: {
                    ...allProducts[index]["metadata"],
                    downloads: allProducts[index]["metadata"]["downloads"] + 1
                }
            }
        }

        const ebooksData = (allProducts || [])?.filter((item) => item?.subCategory === "ebook" && item?.type === "ebook");
        const productsData = (allProducts || [])?.filter((item) => item?.category === "salesforce" && (item?.subCategory === "development" || item?.subCategory === "administration"));

        return {
            ...state,
            productLoading: false,
            allProducts: allProducts,
            products: Array.isArray(productsData) ? productsData : [],
            ebooks: Array.isArray(ebooksData) ? ebooksData : [],
            productsError: null,
            filteredEBooks: [],
            searchTerm: null,
        };
    }

    return state;
};

export default productReducer;
